// **********************************************************
// Product Configuration
// **********************************************************

const toggleCatClass = (parent) => {
  if (parent) {
    const slide = parent.querySelector('.product-configuration__main-slider .swiper-slide-active');
    parent.classList.remove(
      'is-klasik-category',
      'is-bunk-category',
      'is-pop-category',
      'is-trio-category',
      'is-swan-category',
    );
    if (slide?.classList.contains('product-cat-klasik')) parent?.classList.add('is-klasik-category');
    if (slide?.classList.contains('product-cat-bunk')) parent?.classList.add('is-bunk-category');
    if (slide?.classList.contains('product-cat-pop')) parent?.classList.add('is-pop-category');
    if (slide?.classList.contains('product-cat-trio')) parent?.classList.add('is-trio-category');
    if (slide?.classList.contains('product-cat-swan')) parent?.classList.add('is-swan-category');
  }
};

// Check Switch (If Sometime Have Only One Image)
const switchModeCheck = (parent) => {
  const slide = parent.querySelector('.product-configuration__main-slider .swiper-slide-active');
  const switchEle = parent.querySelector('.toggle-switch__input');
  const nightImage = slide?.querySelector('.product-configuration__image--night');
  const dayImage = slide?.querySelector('.product-configuration__image--day');
  switchEle.disabled = !(dayImage && nightImage);
  const onlyNight = nightImage && !dayImage;
  if (onlyNight) {
    switchEle.checked = onlyNight;
    slide?.classList.toggle('is-night-setup', onlyNight);
  }
};

const setProductConfig = (parent) => {
  toggleCatClass(parent);
  switchModeCheck(parent);
  applyNightSetupState(parent);
};

const applyNightSetupState = (parent) => {
  const activeSlide = parent?.querySelector('.product-configuration__main-slider .swiper-slide-active');
  const switchEle = parent?.querySelector('.toggle-switch__input');

  if (!activeSlide || !switchEle) return;

  activeSlide.classList.toggle('is-night-setup', switchEle.checked);
};

const configMainSlider = document.querySelectorAll('[data-slider="configuration-main-slider"]');

const configMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 600,
  watchOverflow: true,
  centerInsufficientSlides: true,
  thumbs: {
    swiper: false,
  },
};

configMainSlider.forEach((el) => {
  const parentElem = el.closest('.product-configuration');
  const configThumbSlider = parentElem.querySelector('[data-slider="tabs-slider"]');

  const options = {
    ...configMainSliderOptions,
    thumbs: { swiper: configThumbSlider },
    on: {
      init() {
        setProductConfig(parentElem);
      },
    },
  };

  const mainSlider = new Swiper(el, options);

  // Update Active Slide Indicator
  mainSlider.on('beforeSlideChangeStart', () => {
    updateActiveIndicator();
  });

  // Toggle Switch and Category Class With Parent
  mainSlider.on('slideChangeTransitionStart', () => {
    // const activeSlide = parentElem.querySelector('.product-configuration__main-slider .swiper-slide-active');
    // const toggleInput = parentElem.querySelector('.toggle-switch__input');
    // if (toggleInput) {
    //   const activeNightSetupSlide = activeSlide.classList.contains('is-night-setup');
    //   toggleInput.checked = !!activeNightSetupSlide;
    // }
    setProductConfig(parentElem);
  });

  // Update InfoBar Width
  const sleepingLayout = parentElem.querySelector('.sleeping-layout');
  const bunkBedEle = sleepingLayout?.querySelector('.sleeping-layout__item--bunk-bed');
  const popOffRoofEle = sleepingLayout?.querySelector('.sleeping-layout__item--pop-off-roof');
  const trioEle = sleepingLayout?.querySelector('.sleeping-layout__item--trio-bed');
  const rearBedEle = sleepingLayout?.querySelector('.sleeping-layout__item--rear-bed');
  const swanBedEle = sleepingLayout?.querySelector('.sleeping-layout__item--swan-bed');

  const bunkBedEleWidth = bunkBedEle?.offsetWidth || 0;
  const popOffRoofEleWidth = popOffRoofEle?.offsetWidth || 0;
  const trioBedEleWidth = trioEle?.offsetWidth || 0;
  const rearBedEleWidth = rearBedEle?.offsetWidth || 0;
  const swanBedEleWidth = swanBedEle?.offsetWidth || 0;

  if (bunkBedEleWidth) sleepingLayout.style.setProperty('--bunk-bed-width', `${bunkBedEleWidth}px`);
  if (popOffRoofEleWidth) sleepingLayout.style.setProperty('--pop-bed-width', `${popOffRoofEleWidth}px`);
  if (trioBedEleWidth) sleepingLayout.style.setProperty('--trio-bed-width', `${trioBedEleWidth}px`);
  if (rearBedEleWidth) sleepingLayout.style.setProperty('--rear-bed-width', `${rearBedEleWidth}px`);
  if (swanBedEleWidth) sleepingLayout.style.setProperty('--swan-bed-width', `${swanBedEleWidth}px`);

  mainSlider.on('slideChangeTransitionEnd', () => {
    sleepingLayout.scrollTo({
      left: sleepingLayout.scrollWidth,
      behavior: 'smooth',
    });
  });
});

// Toggle Day / Night Image
attachEvent('.toggle-switch__input', 'change', (event) => {
  const switchEle = event.target;
  const wrapper = switchEle.closest('.layouts-module__configuration-content-wrapper');
  if (!wrapper) return;

  wrapper.querySelectorAll('.product-configuration').forEach((config) => {
    const toggle = config.querySelector('.toggle-switch__input');
    if (toggle) toggle.checked = switchEle.checked;

    const activeSlide = config.querySelector('.product-configuration__main-slider .swiper-slide-active');
    activeSlide?.classList.toggle('is-night-setup', switchEle.checked);
  });
});

// Change With Cards
attachEvent('.layouts-module .product-card', 'click', (ev) => {
  const card = ev.target.closest('.product-card');
  if (!card) return;

  const mainParent = card.closest('.layouts-module');
  if (!mainParent) return;

  const cards = [...card.parentNode.querySelectorAll('.product-card')];
  const cardIndex = cards.indexOf(card);
  if (cardIndex < 0) return;

  mainParent.querySelectorAll('[data-slider="configuration-main-slider"]').forEach((slider) => {
    slider.swiper?.slideTo(cardIndex);
  });
});

// Sync all configuration main sliders to the clicked tab index
attachEvent('.layouts-module__configuration-content .tabs-slider__tab', 'click', (ev) => {
  const tab = ev.target.closest('.tabs-slider__tab');
  if (!tab) return;

  const tabs = [...tab.closest('.swiper-wrapper').querySelectorAll('.tabs-slider__tab')];
  const tabIndex = tabs.indexOf(tab);
  if (tabIndex < 0) return;

  const parentEle = tab.closest('.layouts-module__configuration-content-wrapper');
  if (!parentEle) return;

  parentEle.querySelectorAll('[data-slider="configuration-main-slider"]').forEach((slider) => {
    slider.swiper?.slideTo(tabIndex);
  });
});
